import React, { useContext, useState } from 'react';
import {
  Nav,
  Navbar,
  Dropdown,
  CustomProvider,
  RadioGroup,
  Form,
  Radio,
} from 'rsuite';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Affix from 'rsuite/Affix';
import i18n from './i18n';
import LocaleContext from './LocaleContext';
import { useTranslation } from 'react-i18next';
import Amplify, { Auth } from 'aws-amplify';

const NavigationHeader = () => {
  function changeLocale(l) {
    if (locale !== l) {
      i18n.changeLanguage(l);
    }
  }
  const navigate = useNavigate();
  const signOut = () => {
    Auth.signOut()
      .then(() => {
        window.location.reload(false);
        navigate('/');
        //this.setState({authState: 'signIn'});
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [activeKey, setActiveKey] = React.useState('/');
  const { locale } = useContext(LocaleContext);
  const location = useLocation();
  const { t } = useTranslation();
  const styles = {
    radioGroupLabel: {
      padding: '8px 2px 8px 10px',
      display: 'inline-block',
      verticalAlign: 'middle',
    },
  };
  const [theme, setTheme] = useState('dark');
  return (
    <CustomProvider theme={theme}>
      <Affix>
        <Navbar>
          <Navbar.Brand href="#">
            {' '}
            <img src="3.png" alt="logo" width={27} height={30} /> KUBOND
          </Navbar.Brand>
          <Nav onSelect={setActiveKey} activeKey={location.pathname}>
            <Nav.Item as={Link} to="/" eventKey="/">
              {t('home')}
            </Nav.Item>
            <Nav.Item as={Link} to="/kubonds" eventKey="/kubonds">
              Kubonds
            </Nav.Item>
            <Nav.Item as={Link} to="/payments" eventKey="/payments">
              {t('payments')}
            </Nav.Item>
            <Nav.Item as={Link} to="/support" eventKey="/support">
              {t('support')}
            </Nav.Item>
            <Dropdown title={t('language')}>
              <Dropdown.Item href="#" onClick={() => changeLocale('en')}>
                english
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => changeLocale('es-MX')}>
                spanish
              </Dropdown.Item>
            </Dropdown>
          </Nav>
          <Nav pullRight>
            <Nav.Item>
              <Form.Group controlId="radioList">
                <RadioGroup
                  name="radioList"
                  inline
                  appearance="picker"
                  value={theme}
                >
                  <span style={styles.radioGroupLabel}>Theme: </span>
                  <Radio onClick={() => setTheme('light')} value="light">
                    light
                  </Radio>
                  <Radio onClick={() => setTheme('dark')} value="dark">
                    dark
                  </Radio>
                </RadioGroup>
              </Form.Group>
            </Nav.Item>
            <Nav.Item onClick={signOut}>Log Out</Nav.Item>
          </Nav>
        </Navbar>
      </Affix>
    </CustomProvider>
  );
};

export default NavigationHeader;
